module.exports = __webpack_public_path__ + "static/sheila_lg-ad9c737d46092f14d5e40977e39eed59.jpg";